/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Správce připojení k síti pro standardní webové technologie.
 * @implements {NetworkManager}
 * @memberof AdapterWeb
 */
class NetworkManager {
  /** @inheritdoc */
  getAllConnections() {
    // Web neumožňuje zjistit dostupná připojení.
    return new Promise((resolve) => resolve([]));
  }
}

export default NetworkManager;
